export default __webpack_public_path__ + "static/media/schema-hepatus.415dbd23.png";